import { render, staticRenderFns } from "./LeaseholdSafety.vue?vue&type=template&id=00f6795a&"
import script from "./LeaseholdSafety.vue?vue&type=script&lang=js&"
export * from "./LeaseholdSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports